export default {
  shortForm(input: number, digits: number): string {
    const lookup = [
      { value: 1, symbol: "" },
      { value: 1e3, symbol: "k" },
      { value: 1e6, symbol: "M" },
      { value: 1e9, symbol: "G" },
      { value: 1e12, symbol: "T" },
      { value: 1e15, symbol: "P" },
      { value: 1e18, symbol: "E" },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    const item = lookup
      .slice()
      .reverse()
      .find(function (item) {
        return input >= item.value;
      });
    return item
      ? (input / item.value)
          .toFixed(digits)
          .replace(rx, "$1")
          .replace(".", ",") + item.symbol
      : "0";
  },
  withThousandsSeparator(number: number, separator: string): string {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  },
  atMostTwoDecimalPlaces(num: number): number {
    return Math.round((num + Number.EPSILON) * 100) / 100;
  },
};
